module.exports = __webpack_public_path__ + "media/images/sp/stores/nara/nara_concept_04-c9a2a3ec0447825b31b3ed13e4265ac3.jpg";